module.exports = __webpack_public_path__ + "img/round-inactive.5360242c.svg";